import { useState } from 'react'
import axios from 'axios'
import Modal from 'react-bootstrap/Modal'
import { useDispatch } from 'react-redux'

import SupportChatModal from 'components/modals/supportChatModal'
import { toggleSupportModal } from 'store/redux/sidebar'

interface IModalProps {
    show: boolean
    onHide: () => void
}
const SupportModal = ({ show, onHide }: IModalProps) => {
    // The chatbot lives here rather than in the layout so this modal owns the
    // whole "contact support" flow: it can hand off to the bot and the bot can
    // hand back when a human is needed.
    const [showChat, setShowChat] = useState(false)
    const dispatch = useDispatch()
    const handleWebhook = async (platform: string) => {
        const profile = JSON.parse(localStorage.getItem('profile')!)
        const data: {
            user_name: string
            user_phone_number: number
            platform: string
        } = {
            user_name:
                profile && profile?.first_name + ' ' + profile?.last_name,
            user_phone_number:
                profile && Number('0' + String(profile?.phone_number.slice(3))),
            platform,
        }
        axios.post(
            'https://support.gethamyan.ir/webhook/monitoring-users-messages',
            { ...data }
        )
    }
    return (
        <>
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" mb-3 px-3">
                    از ساعت 10:30 الی 15 از طریق تماس تلفنی و از ساعت 9 تا 17 در پیام رسان‌ها، پاسخ‌گوی شما عزیزان هستیم.
                </p>
                <hr className=" mb-3" />
                <a
                    className=" text-green-1 my-3 no-underline"
                    onClick={() => {
                        handleWebhook('Call')
                        onHide()
                    }}
                    href="tel:02191070174"
                >
                    تماس تلفنی
                </a>
                <hr className=" mt-3" />
                <p
                    className=" text-green-1 my-3"
                    onClick={() => {
                        handleWebhook('pwa | faq')
                        onHide()
                    }}
                    onClickCapture={() =>
                        window.location.replace(
                            'https://hamyanapp.com/blog/faq'
                        )
                    }
                >
                    سوالات متداول
                </p>
                <hr />
                <p
                    className=" text-green-1 my-3"
                    onClick={() => {
                        handleWebhook('eitta')
                        onHide()
                        window.location.replace('https://eitaa.com/Hamyanapp')
                    }}
                >
                    پیام در ایتا
                </p>
                <hr />
                <p
                    className=" text-green-1 my-3"
                    onClick={() => {
                        handleWebhook('whatsapp')
                        onHide()
                        window.location.replace(
                            'https://t.me/hamyanapp'
                        )
                    }}
                >
                    پیام در تلگرام
                </p>
                <hr />
                {/* Deliberately the LAST option, not the first: this is a trial
                    and the human routes should stay the obvious path until the
                    team has used it enough. Moving it up is a one-line change. */}
                <p
                    className=" text-green-1 my-3"
                    onClick={() => {
                        handleWebhook('pwa | ai chat')
                        onHide()
                        setShowChat(true)
                    }}
                >
                    پرسش از پشتیبان هوشمند{' '}
                    <span className=" text-[10px] text-gray-400">
                        (آزمایشی)
                    </span>
                </p>
                <hr />
                <p className=" mt-4" onClick={onHide}>
                    انصراف
                </p>
            </div>
        </Modal>

        <SupportChatModal
            show={showChat}
            onHide={() => setShowChat(false)}
            onWantsHuman={() => {
                setShowChat(false)
                dispatch(toggleSupportModal({ isOpenSupportModal: true }))
            }}
        />
        </>
    )
}

export default SupportModal
